import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { Image, Table } from 'semantic-ui-react';

import { InstagramIcon, TiktokIcon } from '../../components/dyzio-icons';
import Stories from './stories';
import PlatformLink from './platform-link';
import { ROW_HEIGHT } from './constants';

const DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';

// A discussion holds the influencer directly or via organisations[].influencer.
// One path can resolve to an empty stub, so pick whichever actually has data.
const getInfluencer = discussion => {
  const candidates = [
    discussion.influencer,
    _.get(_.find(discussion.organisations, org => org && org.influencer), 'influencer'),
  ].filter(Boolean);
  return _.find(candidates, i => i.primarySocialHandle || i.name || i.thumbnail) || candidates[0] || {};
};

const InfluencerRow = ({ discussion }) => {
  const influencer = getInfluencer(discussion);
  const handle = influencer.primarySocialHandle || influencer.name || discussion.name;
  const subtitle = influencer.name && handle !== influencer.name ? influencer.name : null;

  return (
    <Table.Row style={{ height: ROW_HEIGHT }}>
      <Table.Cell>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Image
            avatar
            size="mini"
            src={influencer.thumbnail || DEFAULT_IMAGE}
            onError={i => { i.target.src = DEFAULT_IMAGE; }}
            style={{ marginRight: 12, flexShrink: 0 }}
          />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {handle}
            </div>
            {subtitle &&
              <div
                className="light"
                style={{ fontSize: '85%', color: '#9090a0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {subtitle}
              </div>}
          </div>
        </div>
      </Table.Cell>
      <Table.Cell style={{ whiteSpace: 'nowrap' }}>
        {influencer.instagram &&
          <PlatformLink
            href={`https://www.instagram.com/${influencer.instagram}`}
            icon={<InstagramIcon size="large" />}
            handle={influencer.instagram}
            count={influencer.instagramCount}
          />}
        {influencer.tiktok &&
          <PlatformLink
            href={`https://www.tiktok.com/@${influencer.tiktok}`}
            icon={<span style={{ display: 'inline-flex', transform: 'scale(1.4)' }}><TiktokIcon /></span>}
            handle={influencer.tiktok}
            count={influencer.tiktokCount}
          />}
      </Table.Cell>
      <Table.Cell textAlign="center">
        <Stories discussionId={discussion.id} />
      </Table.Cell>
      <Table.Cell
        style={{ color: '#9090a0', whiteSpace: 'nowrap' }}
        title={discussion.lastScannedDate ? moment(discussion.lastScannedDate).format('lll') : ''}
      >
        {discussion.lastScannedDate ? moment(discussion.lastScannedDate).fromNow() : 'Not scanned'}
      </Table.Cell>
    </Table.Row>
  );
};

InfluencerRow.propTypes = {
  discussion: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    workflowStatus: PropTypes.string,
    lastScannedDate: PropTypes.string,
    organisations: PropTypes.array,
  }).isRequired,
};

export default InfluencerRow;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/influencer-row.js
 **/